<style >
.permission-preview-table .el-table__empty-block{
  width: 100%!important;
}
.el-link.el-link--warning{
  font-size: 1rem;
}
</style>

<template>
  <el-drawer :wrapperClosable="false" :visible.sync="visble" size="70%" :show-close="false">
    <template #title>
      <div style="height: 50px">
        <drawer-header title="权限预览" :is-add="false" @close="visble=false" />
      </div>
    </template>
    <div style="padding: 0px 20px;height: calc(100% - 20px);">
      <el-card :body-style="{ padding: '0px 10px'}" class="nexus-el-card" style="height: 100%">
        <div style="margin-top: 10px;">
          <el-form class="demo-form-inline">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item>
                  <el-input v-model="queryParam.name" clearable placeholder="姓名、员工工号、设备工号" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-select v-model="queryParam.deviceId" placeholder="请选择设备" clearable style="width: 100%">
                    <el-option v-for="item in deviceList" :key="item.id" :label="item.name" :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.sn }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-select v-model="queryParam.timeRuleId" placeholder="请选择门禁规则" clearable style="width: 100%">
                    <el-option v-for="item in timeRuleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="handleQueryDeviceTimeRuleList">搜索</el-button>
                  <el-button type="danger" icon="el-icon-delete" style="float: right;" @click="handleBatchDelete">批量删除</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-table class="permission-preview-table" :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}"
                  height="calc(100% - 130px)" @selection-change="handleSelectionChange">
          <template slot="empty">
            <div>
              <img src="@/assets/nodata.png" class="nodata" />
              <div class="nodata_text">暂无数据...</div>
            </div>
          </template>
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="name" label="姓名">
            <template slot-scope="scope">
              <div class="member_name">
                <img :src="scope.row.headUrl" class="member_head" v-if="scope.row.headUrl" />
                <img src="@/assets/head.png" v-else class="member_head" />
                <div>{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="员工工号" prop="jobNumber"></el-table-column>
          <el-table-column prop="departmentName" label="部门"></el-table-column>
          <el-table-column label="设备工号" prop="deviceNumber"></el-table-column>
          <el-table-column label="设备名称">
            <template slot-scope="scope">
              <div v-if="scope.row.deviceName" class="ellipsis">
                {{ scope.row.deviceName }} ({{ scope.row.deviceSn }})
              </div>
              <div v-else>- -</div>
            </template>
          </el-table-column>
          <el-table-column label="门禁规则">
            <template slot-scope="scope">
              <div v-if="scope.row.timeRuleName" class="ellipsis">
                {{ scope.row.timeRuleName }}
              </div>
              <div v-else>- -</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-link type="warning" @click="handleDelete(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-model:current-page="queryParam.pageNum" :page-size="queryParam.pageSize"
                       layout="total, ->, prev, pager, next" :total="total"
                       @current-change="handleCurrentChange" />
      </el-card>
    </div>
  </el-drawer>
</template>


<script>
import DrawerHeader from "@/components/drawerHeader.vue";
import {NexusDeviceApi} from '@/api/nexus/device';
import {TimeRuleApi} from '@/api/nexus/timeRule';
import {DeviceUserTimeRuleApi} from '@/api/nexus/deviceUserRule';
export default {
  components: {
    DrawerHeader
  },
  data() {
    return {
      visble: false,
      queryParam: {
        pageNum: 0,
        pageSize: 20,
        name: '',
        timeRuleId: undefined,
        deviceId: undefined
      },
      deviceList:[],
      timeRuleList:[],
      tableData:[],
      total:0,
      permissions: []
    }
  },
  mounted() {
    // this.init();
  },
  methods: {
    init(){
      NexusDeviceApi.querySimpleList().then( response => {
        let {code,data} = response;
        if(200 == code){
          this.deviceList = data;
        }
      });
      TimeRuleApi.querySimpleList().then( response => {
        let {code,data} = response;
        if(200 == code){
          this.timeRuleList = data;
        }
      });
    },
    handleQueryDeviceTimeRuleList(){
      DeviceUserTimeRuleApi.queryPage(this.queryParam).then( response => {
        let {code,message,data} = response;
        if(200 == code){
          this.tableData = data.list;
          this.total = data.total;
          this.$message.success('查询成功');
        }else {
          this.$message.error(message || '查询失败');
        }
      })
    },
    handleCurrentChange(page){
      this.queryParam.pageNum = page;
      this.handleQueryDeviceTimeRuleList();
    },
    handleSelectionChange(arr) {
      this.permissions = arr;
    },
    async handleDelete(row){
      await this.$confirm("您确定删除该用户设备门禁规则吗", "提示")
      DeviceUserTimeRuleApi.deleteById({userId:row.id,deviceId:row.deviceId}).then(response => {
        let {code,message} = response;
        if(200 == code){
          this.$message.success("删除成功");
          this.handleQueryDeviceTimeRuleList();
        }else {
          this.$message.error(message || '删除失败');
        }
      })
    },
    async handleBatchDelete(){
      if(this.permissions && this.permissions.length>0){
        await this.$confirm("您确定删除选择的用户设备门禁规则吗", "提示")
        let params = this.permissions.map(permission => {
          return {userId: permission.id, deviceId: permission.deviceId};
        });
        DeviceUserTimeRuleApi.batchDelete({list: params}).then(response => {
          let {code,message} = response;
          if(200 == code){
            this.$message.success("删除成功");
            this.permissions = [];
            this.handleQueryDeviceTimeRuleList();
          }else {
            this.$message.error(message || '删除失败');
          }
        })
      }else{
        this.$message.warning('请选择要删除的权限');
      }
    },
    show(){
      this.init();
      this.queryParam = {
        pageNum: 0,
        pageSize: 20,
        name: '',
        timeRuleId: undefined,
        deviceId: undefined
      };
      this.total = 0;
      this.tableData = [];
      this.visble = true;
    }
  },
}
</script>